//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { baseHeaders } from 'util/axios-request';
var baseURL = process.env.VUE_APP_BASE_API;
export default {
  props: {
    title: String
  },
  data: function data() {
    return {
      visible: false,
      uploadUrl: baseURL + 'web/staff/importStaff',
      data: {},
      baseHeaders: baseHeaders()
    };
  },
  methods: {
    init: function init() {
      this.visible = true;
    },
    beforeUploadHandle: function beforeUploadHandle(file) {
      this.data.file_name = file;
      return file;
    },
    successHandle: function successHandle(res) {
      this.$refs.upload.clearFiles();
      this.$emit('getDepUser');
      this.$confirm(this.$t('43', {
        x: res.data.insert_count,
        y: res.data.update_count,
        z: res.data.error_count
      }), this.$t('229'), {
        showCancelButton: false,
        confirmButtonText: this.$t('131'),
        type: 'success'
      });
      window.open(res.data.down_load_excel.object_url);
    }
  }
};